import type { CatalogueItem } from './types';

/**
 * Whether selling this quantity takes the shelf below zero.
 *
 * One definition, used by both the warning the cashier sees and the flag the
 * sale carries. They were computed separately at first, and a banner that says
 * one thing while the recorded event says another is worse than neither: an
 * owner reviewing overrides would be reading a list that does not match what
 * anybody was shown.
 *
 * Made-to-order items are never oversold. Their count comes from materials
 * rather than a shelf, so a zero there is not a shelf running out.
 */
export function soldPastZero(item: CatalogueItem, quantity: number): boolean {
  return item.tracksStock && item.onHand < quantity;
}
